import { Form, setFieldError, useAppForm } from "@birdwatch/ui/form";
import z from "zod";
import { useCheckDiscountCode } from "@/features/my/checkout/_api/use-check-discount-code";
import { useCurrentPurchaseIntent } from "@/features/my/checkout/_api/use-current-purchase-intent";
import { useUpdatePurchaseIntent } from "@/features/my/checkout/_api/use-update-purchase-intent";
import { TextField } from "@/fields";

const formSchema = z.object({
  discountCode: z.string(),
});

export const InputPromoCode = () => {
  const { data: purchaseIntent, refetch: refetchPurchaseIntent } =
    useCurrentPurchaseIntent();
  const { mutateAsync: checkDiscountCode, isPending: isCheckingCode } =
    useCheckDiscountCode();
  const { mutateAsync: updatePurchaseIntent } = useUpdatePurchaseIntent();

  const form = useAppForm({
    defaultValues: {
      discountCode: "",
    },
    validators: {
      onChange: formSchema,
    },
    onSubmit: async ({ value, formApi }) => {
      try {
        const response = await checkDiscountCode({
          couponCode: value.discountCode || "",
        });
        if (!response?.coupon?.valid || !purchaseIntent?.id) {
          setFieldError(
            formApi,
            "discountCode",
            "This code is invalid. Please try again.",
          );
          return;
        }
        // Throws on a non-2xx, so the failure lands in the catch below.
        await updatePurchaseIntent({
          purchaseIntentId: purchaseIntent.id,
          updatePurchaseIntentInput: {
            discountCode: response?.code || "",
          },
        });
        await refetchPurchaseIntent();
      } catch {
        setFieldError(
          formApi,
          "discountCode",
          "This code is invalid. Please try again.",
        );
      }
    },
  });

  return (
    <Form form={form}>
      <div className="flex flex-row items-start justify-between gap-2">
        <div className="flex-auto">
          <TextField name="discountCode" placeholder="Add promotion code" />
        </div>
        <form.SubmitButton size="lg" isPending={isCheckingCode}>
          Apply
        </form.SubmitButton>
      </div>
    </Form>
  );
};
